export default __webpack_public_path__ + "static/media/icon-facebook.34d0ff0f.svg";